<div class="side-info modern-panel" [class.closing]="isClosing()">
    <header class="info-header">
        <div class="header-main">
            <mat-icon fontIcon="assignment" class="header-icon"></mat-icon>

            <input matInput [(ngModel)]="task.text" (blur)="editTask()" class="title-input"
                [attr.aria-label]="'planning.task_name' | translate"
                placeholder="{{ 'planning.task_name' | translate }}" />

            <div class="header-actions">
                <lib-button icon="close" color="none" textColor="muted" tooltip="{{ 'form.close' | translate }}"
                    (click)="close()">
                </lib-button>
            </div>
        </div>

        <ng-container *ngIf="statusUiMap[(task.priority || '').toLowerCase()] as statusUi; else unknownStatus">
            <div class="task-status">
                <app-indicator [color]="statusUi.color" size="medium">
                    <mat-icon [fontIcon]="statusUi.icon"></mat-icon>
                    <span>{{ statusUi.name | translate }}</span>
                </app-indicator>
            </div>
        </ng-container>
    </header>

    <!-- Date task -->
    <div class="info-content">
        <section class="card-section">
            <div class="date-title">
                <mat-icon fontIcon="event_note"></mat-icon>
                <span>Temps prévu</span>
            </div>

            <fieldset class="fieldset">
                <app-range-picker [startDate]="task.startDate?.toString() || ''" [showLabels]="false"
                    [showPlaceholder]="true" [endDate]="task.endDate?.toString() || ''"
                    (change)="onPickerChanged($event)" class="space">
                </app-range-picker>
            </fieldset>
        </section>

        <section class="card-section">
            <div class="date-title">
                <mat-icon fontIcon="schedule"></mat-icon>
                <span>Dates effectives</span>
            </div>

            <fieldset class="fieldset">
                <app-range-picker [startDate]="task.beginDate?.toString() || ''" [showLabels]="false"
                    [showPlaceholder]="true" [endDate]="task.doneDate?.toString() || ''"
                    (change)="onRealDateChanged($event)" class="space">
                </app-range-picker>
            </fieldset>
        </section>

        <!-- Informations progress -->
        <div class="info-divs">
            <ng-container *ngIf="task.buildingProcess?.wall?.measure">
                <section class="volume-progress card-section">
                    <div class="section-title">
                        <div class="section-title">
                            <mat-icon fontIcon="view_week"></mat-icon>
                            <span>{{ 'planning.wall_progress' | translate }}</span>
                        </div>

                        <div class="progress-header"
                            [class.has-progress]="(task.buildingProcess?.wall?.progress ?? 0) > 0">
                            <span class="progress-value">{{ task.buildingProcess?.wall?.progressText }}m</span>
                            <span>/</span>
                            <span class="progress-target">{{ task.buildingProcess?.wall?.measureText }}m</span>
                        </div>
                    </div>

                    <!-- <div class="progress-bar" *ngIf="(task.buildingProcess?.wall?.progress || 0) > 0"> -->
                    <div class="progress-bar">
                        <div class="bar volume" [style.width]="(task.buildingProcess?.wall?.percentText || '0') + '%'">
                        </div>
                    </div>

                    <div class="progress-footer" *ngIf="task.dayProgress">
                        <mat-icon fontIcon="today"></mat-icon>

                        <span>
                            {{ 'planning.day_progress' | translate }} : {{task.buildingProcess?.wall?.dayProgressText}}m
                        </span>
                    </div>
                </section>
            </ng-container>

            <ng-container *ngIf="task.buildingProcess?.floor?.measure">
                <section class="volume-progress card-section">
                    <div class="section-title">
                        <div class="section-title">
                            <mat-icon fontIcon="layers"></mat-icon>
                            <span>{{ 'planning.floor_progress' | translate }}</span>
                        </div>

                        <div class="progress-header"
                            [class.has-progress]="(task.buildingProcess?.floor?.progress ?? 0) > 0">
                            <span class="progress-value">{{ task.buildingProcess?.floor?.progressText }}m2</span>
                            <span>/</span>
                            <span class="progress-target">{{ task.buildingProcess?.floor?.measureText }}m2</span>
                        </div>
                    </div>

                    <!-- <div class="progress-bar" *ngIf="(task.buildingProcess?.floor?.progress || 0) > 0"> -->
                    <div class="progress-bar">
                        <div class="bar volume" [style.width]="(task.buildingProcess?.floor?.percentText || '0') + '%'">
                        </div>
                    </div>

                    <div class="progress-footer" *ngIf="task.dayProgress">
                        <mat-icon fontIcon="today"></mat-icon>

                        <span>
                            {{ 'planning.day_progress' | translate }} : {{task.buildingProcess?.floor?.dayProgressText
                            }}m2
                        </span>
                    </div>
                </section>
            </ng-container>

            <ng-container *ngIf="task.buildingProcess?.column?.measure">
                <section class="volume-progress card-section">
                    <div class="section-title">
                        <div class="section-title">
                            <mat-icon fontIcon="vertical_align_top"></mat-icon>
                            <span>{{ 'planning.column_progress' | translate }}</span>
                        </div>

                        <div class="progress-header"
                            [class.has-progress]="(task.buildingProcess?.column?.progress ?? 0) > 0">
                            <span class="progress-value">{{ task.buildingProcess?.column?.progressText }} </span>
                            <span>/</span>
                            <span class="progress-target">{{ task.buildingProcess?.column?.measureText }}</span>
                        </div>
                    </div>

                    <!-- <div class="progress-bar" *ngIf="(task.buildingProcess?.column?.progress || 0) > 0"> -->
                    <div class="progress-bar">
                        <div class="bar volume"
                            [style.width]="(task.buildingProcess?.column?.percentText || '0') + '%'">
                            {{ task.buildingProcess?.column?.progressText }}
                        </div>
                    </div>

                    <div class="progress-footer" *ngIf="task.dayProgress">
                        <mat-icon fontIcon="today"></mat-icon>

                        <span>
                            {{ 'planning.day_progress' | translate }} : {{task.buildingProcess?.column?.dayProgressText
                            }}
                        </span>
                    </div>
                </section>
            </ng-container>

            <!-- Metrics -->
            <section class="metrics card-section" *ngIf="taskMetrics">
                <div class="list-title">
                    <div class="title">
                        <mat-icon fontIcon="analytics"></mat-icon>
                        <span *ngIf="metricDetail()">Metric Detail</span>
                        <span *ngIf="!metricDetail()">Metrics ({{ displayedMetrics.length }})</span>
                    </div>

                    <lib-button *ngIf="metricDetail()" icon="undo" color="none" textColor="secondary" size="small"
                        tooltip="{{ 'planning.back_to_list' | translate }}" (click)="deselectMetric()">
                    </lib-button>
                </div>

                <div *ngIf="isLoadingMetrics()" class="loading-container">
                    <app-spinner></app-spinner>
                </div>

                <!-- Mode detail or list -->
                <ng-container *ngIf="metricDetail() as metric; else metricsList">
                    <div class="metric-list">
                        <ng-container *ngTemplateOutlet="metricItemTemplate; context: { metric }"></ng-container>
                    </div>
                </ng-container>

                <ng-template #metricsList>
                    <div class="metric-list" (scroll)="onScroll($event)" *ngIf="!isLoadingMetrics()">
                        <ng-container *ngFor="let metric of displayedMetrics; trackBy: trackMetric">
                            <ng-container *ngTemplateOutlet="metricItemTemplate; context: { metric }"></ng-container>
                        </ng-container>

                        <div *ngIf="scrollLoading" class="scroll-loading">
                            <mat-spinner diameter="30" class="spinner"></mat-spinner>
                        </div>
                    </div>
                </ng-template>

                <!-- Template metric detail -->
                <ng-template #metricItemTemplate let-metric="metric">
                    <article class="metric-item">
                        <button class="metric-attachment" *ngIf="metric.attachments?.length"
                            [style.backgroundImage]="'url(' + (metric.attachments[0]?.thumbnail || '') + ')'"
                            (click)="onAttachmentClick(metric)">
                        </button>

                        <!-- Skeleton loading -->
                        <div *ngIf="metric.attachments === undefined" class="skeleton-button"> </div>

                        <!-- Empty attachments -->
                        <div *ngIf="metric.attachments && !metric.attachments.length" class="empty-attachment">
                            <mat-icon fontIcon="image_not_supported"></mat-icon>
                        </div>

                        <div class="metric-info" (click)="onMetricClick(metric)">
                            <div class="metric-title">{{ metric.payload.prediction }}</div>
                            <div class="metric-meta">
                                <div class="item" *ngIf="metric.payload.startDate">
                                    <mat-icon fontIcon="today"
                                        matTooltip="{{ 'datatable.createdDate' | translate }}"></mat-icon>
                                    <span>{{ metric.payload.startDate | date: 'dd-MM-yyyy HH:mm' }}</span>
                                </div>
                                <div class="item" *ngIf="metric.payload.duration">
                                    <mat-icon fontIcon="timer"
                                        matTooltip="{{ 'planning.duration' | translate }}"></mat-icon>
                                    <span>{{ parseDuration(metric.payload.duration) }}</span>
                                </div>
                                <div class="item" *ngIf="metric.volume">
                                    <mat-icon fontIcon="view_in_ar"
                                        matTooltip="{{ 'planning.volume' | translate }}"></mat-icon>
                                    <span>{{ metric.payload.volumeText }}m3</span>
                                </div>
                                <div class="item" *ngIf="metric.createdDate">
                                    <button class="timeline-btn" (click)="redirectToTimeline($event, metric)"
                                        matTooltip="{{'planning.redirection_timeline' | translate}}">
                                        <mat-icon fontIcon="timeline"></mat-icon>
                                    </button>
                                </div>
                            </div>
                        </div>
                    </article>
                </ng-template>
            </section>
        </div>
    </div>

    <footer class="delete">
        <lib-button icon="delete" color="danger" tooltip="{{ 'planning.delete_task' | translate }}"
            (click)="deleteTask()"></lib-button>
    </footer>
</div>

<!-- Templates -->
<ng-template #unknownStatus>
    <div class="task-status">
        <app-indicator [color]="defaultStatusUi.color" size="medium">
            <mat-icon [fontIcon]="defaultStatusUi.icon"></mat-icon>
            <span>{{ 'status.unknown' | translate }}</span>
        </app-indicator>
    </div>
</ng-template>